import { SelectionGroupOption } from 'common/components';
import { WINDOWS_CDN_PATH } from '../../windows-constants';

export type WindowsTypeCardStructure = {
  imgSrc: string;
  modalImgSrc: string;
  title: string;
  description: string;
};

export const WINDOWS_PROJESTS_SELECTION_GROUP: SelectionGroupOption[] = [
  {
    value: 'cottages',
    text: 'Коттеджи, частные дома и дачи',
  },
  {
    value: 'apartments',
    text: 'Квартиры',
  },
  {
    value: 'balconies',
    text: 'Балконы и лоджии',
  },
  {
    value: 'commercialPremises',
    text: 'Коммерческие помещения',
  },
];

const COTTAGES_PROJECTS_LIST = [
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/cottages/home.jpg/home-01.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/cottages/home.jpg/home-01.jpg`,
    title: 'Окна для дома',
    description: 'Надёжные окна, которые защищают пространство от\u00A0холода, ветра и\u00A0шума. Доступны любые размеры, даже нестандартные, чтобы каждое окно идеально вписалось в\u00A0ваш дом.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/cottages/terraces.jpg/terraces-01.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/cottages/terraces.jpg/terraces-01.jpg`,
    title: 'Остекление террасы, веранды, беседки',
    description: 'Окна, которые превратят террасу или веранду в\u00A0уютное и\u00A0тёплое пространство, при этом сохраняя свет и\u00A0открытый обзор, чтобы не\u00A0переставать наслаждаться пейзажем.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/cottages/soft-windows.jpg/soft-windows.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/cottages/soft-windows.jpg/soft-windows-01.jpg`,
    title: 'Мягкие окна',
    description: 'Лёгкое и\u00A0недорогое решение для беседок, террас и\u00A0веранд. Такие окна защищают от\u00A0ветра и\u00A0дождя, легко открываются и\u00A0складываются, создавая комфортное пространство на\u00A0свежем воздухе.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/cottages/glass-doors.jpg/glass-doors-01.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/cottages/glass-doors.jpg/glass-doors-01.jpg`,
    title: 'Входные пластиковые двери',
    description: 'Входная дверь\u00A0\u2014 конструкция, которая устанавливается на\u00A0входе как в\u00A0частных домах, так и\u00A0в\u00A0коммерческих помещениях. Допускает установку ударостойких и\u00A0сверхпрочных стекол дверных заполнений, доступны варианты различных цветов',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/cottages/panoramic-glazing.jpg/panoramic-glazing-01.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/cottages/panoramic-glazing.jpg/panoramic-glazing-01.jpg`,
    title: 'Панорамное остекление',
    description: 'Панорамные окна наполнят дом светом на\u00A0максимум. Отличное решение для комнаты отдыха, кухни или столовой\u00A0\u2014 чтобы с\u00A0комфортом проводить время и\u00A0любоваться пейзажем.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/cottages/sliding-portals.jpg/sliding-portals-01.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/cottages/sliding-portals.jpg/sliding-portals-01.jpg`,
    title: 'Раздвижные порталы',
    description: 'Большие раздвижные двери легко открываются, превращая комнату, террасу или веранду в\u00A0единое пространство с\u00A0улицей. Пропускают много света и\u00A0сделают любое помещение дышащим и\u00A0просторным.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/cottages/dormer-windows.jpg/dormer-windows-02.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/cottages/dormer-windows.jpg/dormer-windows-02.jpg`,
    title: 'Мансардные окна',
    description: 'Специальные окна для крыши, которые наполнят комнату светом и\u00A0создадут ощущение простора. Отличный способ сделать чердачное или мансардное пространство уютным и\u00A0комфортным для жизни.',
  },
];

const APPARTMENTS_PROJECTS_LIST = [
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/appartments/simple.jpg/simple.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/appartments/simple.jpg/simple.jpg`,
    title: 'Простые окна',
    description: 'Простое окно\u00A0\u2014 типовое и\u00A0недорогое решение для остекления квартиры или дома. В\u00A0нем нет усложняющих и\u00A0удорожающих изготовление элементов. Как правило, такое окно имеет прямоугольную форму, стандартный дизайн и\u00A0белый цвет.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/appartments/anti-burglary.jpg/anti-burglary.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/appartments/anti-burglary.jpg/anti-burglary.jpg`,
    title: 'Противовзломные окна',
    description: 'Эти окна с\u00A0прочным антивандальным стеклопакетом, усиленным ПВХ-профилем и\u00A0надёжной фурнитурой. Такое окно защитит ваш дом от\u00A0проникновения злоумышленников.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/appartments/noise-protection.jpg/noise-protection.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/appartments/noise-protection.jpg/noise-protection.jpg`,
    title: 'Окна с защитой от шума',
    description: 'Рекомендуем эти окна для домов и\u00A0квартир, которые находятся рядом с\u00A0оживлёнными дорогами, автомагистралями, аэропортами и\u00A0другими источниками шума. Создайте спокойную и\u00A0тихую атмосферу.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/appartments/energy-saving.jpg/energy-saving.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/appartments/energy-saving.jpg/energy-saving.jpg`,
    title: 'Энергосберегающие окна',
    description: 'Окна, где каждый элемент помогает поддерживать комфортную температуру в\u00A0доме. Специальное напыление на\u00A0стекле защищает от\u00A0холода зимой и\u00A0знойного солнца летом. Отличная экономия на\u00A0отоплении и\u00A0кондиционировании.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/appartments/for-children.jpg/for-children-01.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/appartments/for-children.jpg/for-children.jpg`,
    title: 'Окна для детской',
    description: 'Решение, которое сделает детскую комнату максимально безопасной. Такие окна открывается только на\u00A0проветривание, а\u00A0для полного открытия понадобится специальный ключ.',
  },
];

const BALCONIES_PROJECTS_LIST = [
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/balconies/cold-glazing.jpg/cold-glazing.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/balconies/cold-glazing.jpg/cold-glazing.jpg`,
    title: 'Холодное остекление',
    description: 'Лёгкое и\u00A0доступное решение для балконов и\u00A0лоджий. Такие окна защищают от\u00A0ветра, дождя и\u00A0пыли, а\u00A0также делают пространство аккуратным и\u00A0уютным. Хороший вариант, если не\u00A0требуется поддерживать комфортную температуру круглый год.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/balconies/balconies.jpg/balconies.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/balconies/balconies.jpg/balconies.jpg`,
    title: 'Балконы и лоджии',
    description: 'Надёжное решение для тех, кто хочет пользоваться балконом или лоджией круглый год. Такие окна хорошо сохраняют тепло, защищают от\u00A0сквозняков и\u00A0делают пространство жилым и\u00A0комфортным\u00A0\u2014 как ещё одну комнату в\u00A0доме.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/balconies/interior-decoration.jpg/interior-decoration.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/balconies/interior-decoration.jpg/interior-decoration.jpg`,
    title: 'Внутренняя отделка балконов',
    description: 'Сделаем балкон уютным и\u00A0полностью готовым к\u00A0использованию. Пространство станет тёплым и\u00A0удобным\u00A0\u2014 для отдыха, работы или хранения.',
  },
];

const COMMERCIAL_PREMISES_PROJECTS_LIST = [
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/commercial-premises/pvc.jpg/pvc.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/commercial-premises/pvc.jpg/pvc.jpg`,
    title: 'Пластиковые окна ПВХ',
    description: 'Это современный стандарт надёжности, энергоэффективности и\u00A0безупречного дизайна.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/commercial-premises/aluminum-windows.jpg/aluminum-windows.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/commercial-premises/aluminum-windows.jpg/aluminum-windows.jpg`,
    title: 'Алюминиевые окна',
    description: 'Прочные и\u00A0стильные окна для офисов, павильонов, торговых помещений. Лёгкие, долговечные и\u00A0устойчивые к\u00A0погоде\u00A0\u2014 сделают вид здания современным и\u00A0аккуратным.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/commercial-premises/aluminum-doors.jpg/aluminum-doors.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/commercial-premises/aluminum-doors.jpg/aluminum-doors.jpg`,
    title: 'Алюминиевые двери',
    description: 'Долговечные, современные и\u00A0надежные конструкции обеспечивают комфорт и\u00A0безопасность.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/commercial-premises/fire-doors.jpg/fire-doors.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/commercial-premises/fire-doors.jpg/fire-doors.jpg`,
    title: 'Противопожарные двери',
    description: 'Надёжная защита для офисов, складов и\u00A0общественных помещений. Такие двери замедляют распространение огня и\u00A0дыма, помогая людям безопасно покинуть помещение.',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/commercial-premises/partitions.jpg/partitions.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/commercial-premises/partitions.jpg/partitions.jpg`,
    title: 'Перегородки',
    description: 'Удобный способ разделить помещение на\u00A0зоны, не\u00A0теряя света и\u00A0простора. Отлично подходят для офисов, магазинов и\u00A0других общественных пространств.',
  },
];

export const WINDOWS_PROJECT_TYPES_LIST: Record<string, WindowsTypeCardStructure[]> = {
  cottages: COTTAGES_PROJECTS_LIST,
  apartments: APPARTMENTS_PROJECTS_LIST,
  balconies: BALCONIES_PROJECTS_LIST,
  commercialPremises: COMMERCIAL_PREMISES_PROJECTS_LIST,
};
